import React, { useState, useEffect } from "react";
import SearchResults from "./SearchResults";
import { Button } from "react-bootstrap";
import { useLocation, useHistory } from 'react-router-dom'
import { Banner } from '../../template/Banner'

function Search(props) {
  let history = useHistory();
  const location = useLocation()
  const { term } = location.state || '';  
  const { tWorks, tPeople, tPlaces }  = location.state || true;

  const [searchTerm, setSearchTerm] = useState(term);
  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  }

  const [targetWorks, setTargetWorks] = useState(true);
  const handleTargetWorksChange = (event) => {
    setTargetWorks(event.target.checked);
    if (!event.target.checked) {
      setTargetAll(false);
    }
  }

  const [targetPeople, setTargetPeople] = useState(true);
  const handleTargetPeopleChange = (event) => {
    setTargetPeople(event.target.checked);
    if (!event.target.checked) {
      setTargetAll(false);
    }
  }

  const [targetPlaces, setTargetPlaces] = useState(true);
  const handleTargetPlacesChange = (event) => {
    setTargetPlaces(event.target.checked);
    if (!event.target.checked) {
      setTargetAll(false);
    }
  }

  const [targetAll, setTargetAll] = useState(true);
  const handleTargetAllChange = (event) => {
    setTargetWorks(event.target.checked);
    setTargetPeople(event.target.checked);
    setTargetPlaces(event.target.checked);
    setTargetAll(event.target.checked);
  }

  const [data, setData] = useState({"persons": [], "places": [], "works": []});
  const performSearch = () => {
    fetch(`http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/search/basic?term=${searchTerm}`)
        .then(res => res.json())
        .then(result => setData(result))
        .catch(console.log);
        console.log(data);
  }

  useEffect(() => {
    if (term !== undefined) {
      performSearch();
      setShow(true);
    }
    if (tWorks !== undefined && !tWorks) {
      setTargetWorks(false);
      setTargetAll(false);
    }
    if (tPeople !== undefined && !tPeople) {
      setTargetPeople(false);
      setTargetAll(false);
    }
    if (tPlaces !== undefined && !tPlaces) {
      setTargetPlaces(false);
      setTargetAll(false);
    }
  }, [term, tWorks, tPeople, tPlaces]);

  const [show, setShow] = useState(false);
  const handleSearch = e => {
    e.preventDefault();
    performSearch();
    setShow(true);
  }

  return (
    <div className="search">
      
      <Banner />
      <div className="page-box-tab">
        <button className="tablinks link-simple-search active"><img src="search.png" alt="" />Simple search</button>
        <button className="tablinks link-adv-search inactive" onClick={() => { history.push('/search/advanced') }}><img src="advanced.png" alt="" />Advanced search</button>
        <button className="tablinks link-works" onClick={() => { history.push('/works') }}><img src="publishing.png" alt="" />Works</button>
        <button className="tablinks link-people" onClick={() => { history.push('/persons') }}><img src="profile.png" alt="" />People</button>
        <button className="tablinks link-places" onClick={() => { history.push('/places') }}><img src="location.png" alt="" />Places</button>
      </div>
      
      <div className="container">
        <div className="search-page-container">

          <div className="search-page-content">

            <form onSubmit={handleSearch}>

              <div className="searchpage-search-box">
                <div className="search-line">
                  <input type="text" className="form-control" aria-describedby="term" placeholder="search term" value={searchTerm} onChange={handleChange} />  
                  <Button className="btn btn-default active" type="submit">
                    <img src="search.png" alt="" />
                  </Button>
                  <div className="search-checkboxes">
                    <input type="checkbox" checked={targetWorks} onChange={handleTargetWorksChange} />
                    Works
                    <input type="checkbox" checked={targetPeople} onChange={handleTargetPeopleChange} />
                    People
                    <input type="checkbox" checked={targetPlaces} onChange={handleTargetPlacesChange} />
                    Places
                    <input type="checkbox" checked={targetAll} onChange={handleTargetAllChange} />
                    All
                  </div>
                </div>
              </div>

            </form>

            { show && <SearchResults data={data} targetWorks={targetWorks} targetPeople={targetPeople} targetPlaces={targetPlaces} type="basic" /> }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Search;